import { TGDComponent } from '../../../models/courses/graphicDesign';
import { TBox } from './snapping';

export const polygonPoints = (sides: number, width: number, height: number): number[] => {
  if (!Number.isInteger(sides) || sides < 3) return [];
  return Array.from({ length: sides }, (_, index) => {
    const angle = -Math.PI / 2 + index * 2 * Math.PI / sides;
    return [width / 2 + Math.cos(angle) * width / 2,
      height / 2 + Math.sin(angle) * height / 2];
  }).flat();
};

export interface TNodeTransform {
  x: number; y: number; scaleX: number; scaleY: number; rotation: number;
}

export const toNodeTransform = (c: TGDComponent): TNodeTransform => ({
  x: c.x + c.width / 2, y: c.y + c.height / 2,
  scaleX: 1, scaleY: 1, rotation: c.rotation,
});

export const fromNodeTransform = (c: TGDComponent, t: TNodeTransform):
  Partial<Omit<TGDComponent, 'id' | 'type'>> => {
  const width = c.width * Math.abs(t.scaleX);
  const height = c.height * Math.abs(t.scaleY);
  return {
    x: t.x - width / 2, y: t.y - height / 2, width, height,
    rotation: t.rotation,
    ...(c.type === 'text' ? { fontSize: (c.fontSize ?? 16) * Math.abs(t.scaleY) } : {}),
  };
};

export const componentBox = (c: TGDComponent): TBox => ({
  x: c.x, y: c.y, width: c.width, height: c.height,
});
